import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, Paper, TextField, Checkbox } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import api from "../../API";
import { setCodeInfo } from "../../redux/slice/code";
import { SearchBackDrop } from "./common/SearchBackDrop";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

const LoginPage = (props:any) => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isRemember, setIsRemember] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(['insightEmail']);
  const [session, setSession, removeSession] = useCookies(['session']);

  let now = new Date;
  let after1mon = new Date;

  // const checkIp = async () => {
  //   console.log('checkIp')
  //   // ipify API를 통해 IP 정보 가져오기
  //   await api.get('https://ipapi.co/json/')
  //   .then(response => {
  //     console.log('현재 IP:', response);
  //   })
  //   .catch(error => {
  //     console.error('IP 정보를 가져오는 중 오류가 발생했습니다:', error);
  //   });
  // }

  const handleEmailChange = (e:any) => {
    setEmail(e.target.value);
    if (isRemember) {
      rememberCookie(true, e.target.value);
    }
  };

  const handleOnChange = (e:any) => {  // CheckBox 값 변경 시
    setIsRemember(e.target.checked);
    if(e.target.checked) {
      rememberCookie(true, email); // 현재 email로 쿠키 저장
    } else {
      rememberCookie(false, "");
    }
  }

  const rememberCookie = (checked : Boolean, p_email : string) => {
    if(checked){  // checkBox를 체크할시
      after1mon.setMonth(now.getMonth() +1); // after1mon를 현재시간의 한달뒤로 정의
      // console.log('한달뒤 ??? ' , after1mon)
      setCookie('insightEmail', p_email, {path:'/', expires:after1mon});
      // insightEmail에 email라는 값을 넣는다.
      // path는 적용되는 도메인
      // expires = 만료시간은 한달뒤
    } else { // checkBox의 체크를 지울시
      removeCookie('insightEmail'); // 쿠키 insightEmail를 지운다
    }
  }
  
  const open = props.switchPage;
  var control = 'flex';
  if(open)
    control = 'none'


  const logInUser = useCallback(async () => {
    setBackdrop(true)
    try {
      // console.log('logInUser loc ' , loc, window.location)
      // const resp = await httpClient.post("//121.135.229.125:4546/login", {
      // const resp = await axios.post("http://localhost:9680/login",
      // console.log(window.location.origin.replace(':3000',':9680').replace('http','https')+"/login")
      // const resp = await axios.post(window.location.origin.replace(':3000',':9680').replace('http','https')+"/login",
      // // const resp = await axios.post(window.location.origin.replace(':3000',':9680')+"/login",
      //   {email:email,password:password},
      //   {withCredentials: true});

      // const vieText = await api.get('/getVieText')
      // console.log('vieText',vieText.data)

      const resp_login = await api.post('/login', {email:email,password:password})
      // console.log('resp', resp_login.data)
      // setSession('session', p_email, {path:'/', expires:after1mon});

      dispatch(setUserInfo(resp_login.data))

      const resp_auth = await api.get('/getAuths')
      console.log('resp',resp_auth.data)

      dispatch(setCodeInfo(resp_auth.data))
      
      // let route_page = auth.user.roles.some((obj:any) => ['ADMIN','MANAGER','WORKER_DIALOG','WORKER_SOUND','WORKER_NOISE'].includes(obj.role));


      if(resp_login.data.roles.some((obj:any) => ['ADMIN','MANAGER','WORKER_DIALOG','WORKER_SOUND','WORKER_NOISE'].includes(obj.role)))
        // nav("/admin/hrm/dialogSample");
        nav("/admin");
      else
        nav("/");
    } catch (error:any) {
      console.log('error',error)
      if (error.response.status === 401) {
        alert("로그인에 실패하였습니다. 아이디와 페스워드를 확인해주세요.");
      }
    }
    setBackdrop(false)
  }, [email, password]);

  const handleKeyPress = useCallback((event:any) => {
    // 엔터 로그인
    if (event.key === 'Enter') {
      event.preventDefault(); // 브라우저의 기본 동작을 방지
      // console.log('업데이트 진행 준비' , p_gub_nam , p_sub_gub_nam)
      logInUser()
    }
  }, [logInUser]);

  useEffect(() => {
    if(cookies.insightEmail !== undefined){
      setEmail(cookies.insightEmail);
      setIsRemember(true);
    }
    document.addEventListener('keydown', handleKeyPress);
    // remove the event listener
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
    // checkIp();
  },[handleKeyPress]);

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box sx={{display: control, justifyContent: "center", padding:"72px"}}>
      {backdrop && ( <SearchBackDrop message={"접속중..."}/> )}
        <Paper sx={{ margin: "0px", padding: "16px", borderTop: "4px solid #3e36a5"}}>
          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "20px", letterSpacing:"-2px"}}>로그인</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <form>
              {/* <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} id="email" type="email" label="아이디(이메일)을 입력해주세요" variant="outlined" fullWidth size="small" value={email} onChange={(e) => setEmail(e.target.value)}  /> */}
              <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} id="email" type="email" label="아이디(이메일)을 입력해주세요" variant="outlined" fullWidth size="small" value={email} onChange={handleEmailChange}  />
              <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} id="password" type="password" label="비밀번호를 입력해주세요" variant="outlined" fullWidth size="small" value={password} onChange={(e) => setPassword(e.target.value)}  />
              <Box sx={{display:"flex", justifyContent: "center", padding:1}}>
                <Checkbox sx={{alignSelf:"center"}} onChange={handleOnChange} checked={isRemember}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>아이디저장</Box>    
              </Box>
              <Box sx={{display:"flex", justifyContent: "center"}}>
                <Box width="50%" textAlign="center">
                <Button sx={{width:"80%", height:"38px", magin:"24px", fontSize:"20px", fontWeight:700, color:"#fff", backgroundColor:"#3e36a5",':hover': {bgcolor: '#4caf50', color: 'black'}, letterSpacing:"4px"}} type="button" onClick={() =>  {if(isRemember){rememberCookie(true,email)} logInUser();}}>로그인</Button>
                </Box>
                <Box width="50%" textAlign="center">
                  <Button sx={{width:"80%", height:"38px", magin:"24px", fontSize:"20px", fontWeight:700, color:"#fff", backgroundColor:"#3e36a5",':hover': {bgcolor: '#4caf50', color: 'black'}, letterSpacing:"4px"}} type="button" onClick={() => props.setSwitchPage(true)}>가입신청</Button>
                </Box>
              </Box>
            </form>
          </Box>
        </Paper>
    </Box>
  );
};

export default LoginPage;
